<template>
  <header class="sticky top-0 z-50 transition-all duration-300" :style="{
    backgroundColor: `rgba(31, 41, 55, ${scrollOpacity})`,
    boxShadow: scrollY > 50 ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)' : 'none'
  }">
    <div class="container mx-auto px-4">
      <div class="flex justify-between items-center py-4">
        <!-- 品牌Logo -->
        <router-link to="/" class="text-2xl font-bold text-white">
          <img src="@/assets/jyq-logo.png" alt="N733 Resin Premium Thermal Transfer Ribbon"
                class="h-10">
          <!-- logo图标 -->
        </router-link>

        <!-- 桌面端菜单 -->
        <nav class="hidden md:flex items-center space-x-8">
          <router-link to="/" class="text-white hover:text-gray-200 transition-colors relative">
            <span class="nav-underline">HOME</span>
          </router-link>

          <router-link to="/introduce" class="text-white hover:text-gray-200 transition-colors relative">
            <span class="nav-underline">INTRODUCE</span>
          </router-link>
          <router-link to="/products" class="text-white hover:text-gray-200 transition-colors relative">
            <span class="nav-underline">PRODUCT</span>
          </router-link>

          <router-link to="/news" class="text-white hover:text-gray-200 transition-colors relative">
            <span class="nav-underline">NEWS</span>
          </router-link>

          <!-- 关于下拉菜单 -->
          <div class="relative group">
            <!-- 关键：添加 :class 绑定，判断当前路径是否以 /about 开头 -->
            <div :to="{ name: 'AboutPage' }"
              class="flex items-center text-white hover:text-gray-200 transition-colors relative"
              :class="{ 'active-about': $route.path.startsWith('/about') }">
              <span class="nav-underline">ABOUT</span>
              <i class="fa fa-chevron-down ml-1 text-xs"></i>
            </div>
            <!-- 子菜单路由链接（保持不变） -->
            <div
              class="absolute left-0 mt-2 w-48 bg-white shadow-lg rounded-md overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform origin-top scale-95 group-hover:scale-100">
              <router-link to="/about/Cases" class="block px-4 py-2 hover:bg-gray-100 transition-colors text-gray-800">
                CASES
              </router-link>
              <router-link to="/about/factory"
                class="block px-4 py-2 hover:bg-gray-100 transition-colors text-gray-800">
                Factory Scene
              </router-link>
            </div>
          </div>

          <router-link to="/contact" class="text-white hover:text-gray-200 transition-colors relative">
            <span class="nav-underline">CONTACT US</span>
          </router-link>
        </nav>

        <!-- 移动端菜单按钮 -->
        <button class="md:hidden text-white z-50" @click="toggleMobileMenu" aria-label="Menu">
          <i class="fa fa-bars text-xl"></i>
        </button>
      </div>
    </div>

    <!-- 移动端侧边导航 -->
    <div class="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden transition-opacity duration-300"
      v-if="isMobileMenuOpen" @click="toggleMobileMenu"></div>

    <!-- 修复：使用相对宽度 + 最大宽度限制，避免溢出 -->
    <div
      class="fixed top-0 right-0 h-full w-[80%] max-w-xs bg-white shadow-2xl z-50 md:hidden transition-transform duration-300 ease-in-out"
      :style="{ transform: isMobileMenuOpen ? 'translateX(0)' : 'translateX(100%)' }">
      <div class="flex justify-end p-4 border-b">
        <button @click="toggleMobileMenu" class="text-gray-500 hover:text-gray-800">
          <i class="fa fa-times text-xl"></i>
        </button>
      </div>

      <div class="p-4 space-y-4">
        <!-- HOME 菜单：判断路径是否为 / -->
        <router-link to="/" class="block py-2 text-gray-800 hover:text-primary"
          :class="{ 'text-primary font-medium': $route.path === '/' }"
          @click="toggleMobileMenu"
          >
          HOME
        </router-link>

        <!-- 恢复之前注释的 PRODUCT 和 NEWS 菜单（如果需要），并添加高亮 -->
        <router-link to="/products" class="block py-2 text-gray-800 hover:text-primary"
          :class="{ 'text-primary font-medium': $route.path.startsWith('/products') }"
          @click="toggleMobileMenu"
          >
          PRODUCT
        </router-link>

        <router-link to="/news" class="block py-2 text-gray-800 hover:text-primary"
          :class="{ 'text-primary font-medium': $route.path.startsWith('/news') }"
          @click="toggleMobileMenu"
          >
          NEWS
        </router-link>

        <!-- ABOUT 下拉菜单（已处理高亮，保持不变） -->
        <div>
          <button class="flex justify-between items-center w-full py-2 text-gray-800"
            :class="{ 'text-primary font-medium': $route.path.startsWith('/about') }"
            @click="isAboutSubmenuOpen = !isAboutSubmenuOpen">
            <span>ABOUT</span>
            <i class="fa fa-chevron-down text-xs" :class="{ 'rotate-180': isAboutSubmenuOpen }"></i>
          </button>

          <div class="pl-4 mt-2 space-y-2 " v-if="isAboutSubmenuOpen">
            <!-- ABOUT 子菜单：精确匹配路径 -->
            <router-link to="/about/Cases" class="block py-2 text-gray-800 hover:text-primary"
              :class="{ 'text-primary font-medium': $route.path === '/about/application' }" @click="toggleMobileMenu">
              CASES
            </router-link>
            <router-link to="/about/factory" class="block py-2 text-gray-800 hover:text-primary"
              :class="{ 'text-primary font-medium': $route.path === '/about/factory' }" @click="toggleMobileMenu">
              Factory Tour
            </router-link>
          </div>
        </div>

        <!-- CONTACT US 菜单：精确匹配路径 -->
        <router-link to="/contact" class="block py-2 text-gray-800 hover:text-primary"
          :class="{ 'text-primary font-medium': $route.path === '/contact' }" @click="toggleMobileMenu">
          CONTACT US
        </router-link>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

// 移动端菜单状态
const isMobileMenuOpen = ref(false)
const isAboutSubmenuOpen = ref(false)

// 滚动状态管理
const scrollY = ref(0)
const scrollOpacity = ref(1) // 初始不透明（100%）

// 处理滚动事件
const handleScroll = () => {
  scrollY.value = window.scrollY

  // 优化滚动透明度逻辑：滚动时逐渐加深背景，避免在浅色内容区看不清
  if (scrollY.value <= 100) {
    scrollOpacity.value = 1 - (scrollY.value / 100) * 0.5 // 最多降低50%透明度（更清晰）
  } else {
    scrollOpacity.value = 0.5 // 保持50%不透明度（兼顾美观和可读性）
  }
}

// 监听滚动事件
onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

// 切换菜单显示/隐藏
const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
  // 修复：避免body溢出影响
  document.body.style.overflow = isMobileMenuOpen.value ? 'hidden' : ''
  document.body.style.paddingRight = isMobileMenuOpen.value ? '0' : '' // 移除可能的右侧留白
}
</script>

<style scoped>
/* 导航栏下划线动画 */
.nav-underline {
  position: relative;
  display: inline-block;
}

.nav-underline::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: white;
  transition: width 0.3s ease;
  transform-origin: center;
}

/* 修复：使用精确的深度选择器，避免影响其他组件 */
:deep(a:hover) .nav-underline::after {
  width: 100%;
}

:deep(.router-link-exact-active) .nav-underline::after {
  width: 100%;
}

/* 确保侧边栏不超出屏幕 */
@media (max-width: 360px) {
  .max-w-xs {
    max-width: 280px;
    /* 在极小屏幕上进一步限制宽度 */
  }
}

.active-about .nav-underline::after {
  width: 100%;
  /* 保持下划线高亮 */
}



/* 移动端菜单激活高亮（文字颜色 + 加粗） */
.text-primary {
  color: #165DFF !important;
  /* !important 确保优先级高于默认颜色 */
}

.font-medium {
  font-weight: 500;
  /* 可选：激活时加粗，增强视觉效果 */
}
</style>